import { countTime } from './count-time';
import type { IHandleNoAuthResultResponseArgs } from './models';

export const handleNoAuthResultResponse = ({
    availableSignMethods,
    change,
}: IHandleNoAuthResultResponseArgs) => {
    change('codeResponseRestCount', availableSignMethods.codeResponseRestCount);
    change('signCodeError', 'Код введён неверно');
    change('signCode', '');
    change('confirmation.countdownDuration', countTime(availableSignMethods?.newCodeRequestTime));
    change('confirmation.countdownDuration', countTime(availableSignMethods?.newCodeRequestTime));
    change('confirmation.state', 'CODE_ERROR');
    change('confirmation.hideCountdownSection', false);
};
